import React, { Component } from 'react';
import { Props } from './Pips.types';
import { Wrapper } from './Pips.styles';

class Pips extends Component<Props> {
  shouldComponentUpdate(nextProps: Props) {
    return (
      nextProps.width !== this.props.width ||
      nextProps.length !== this.props.length ||
      nextProps.lastItem !== this.props.lastItem
    );
  }
  render() {
    return <Wrapper {...this.props}>{this.props.children}</Wrapper>;
  }
}
export default Pips;
